"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("@citrus/button");
var _banner = require("@citrus/banner");
var _drawer = require("@citrus/drawer");
var _inputWysiwyg = require("@citrus/input-wysiwyg");
var _layout = require("@citrus/layout");
var _modal = require("@citrus/modal");
var _tabs = require("@citrus/tabs");
var _questionBuilder = require("@pcty/question-builder");
var _get = _interopRequireDefault(require("@pcty/utils-commonjs/object/get"));
var _lodash = _interopRequireDefault(require("lodash.isequal"));
var _lodash2 = _interopRequireDefault(require("lodash.uniq"));
var _PctyQuestionBuilderEdit = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.Question"));
var _PctyQuestionBuilderEdit2 = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.Knockout"));
var _PctyQuestionBuilderEdit3 = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.HintsAndResponses"));
var _PctyQuestionBuilderEdit4 = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.Conditional"));
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Constants");
var _PctyQuestionBuilder2 = require("./PctyQuestionBuilder.Common");
require("./index.css");
var _p, _p2, _p3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PctyQuestionBuilderEditDrawer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionBuilderEditDrawer, _Component);
  var _super = _createSuper(PctyQuestionBuilderEditDrawer);
  function PctyQuestionBuilderEditDrawer(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionBuilderEditDrawer);
    _this = _super.call(this, props);
    var edit = (0, _PctyQuestionBuilder2.assignOptionIds)(_this.props.edit);
    _this.state = {
      _mounted: false,
      tab: props.activeTab === 'conditional' ? 1 : 0,
      edit: edit,
      initialEdit: edit,
      newCompetency: '',
      showScenario: false,
      rawScenarioContentState: null,
      validationState: {},
      modals: {
        leave: false,
        areYouSure: false
      }
    };
    _this.trueValidationState = {
      answer: {
        valid: false,
        errorMessage: 'You must have text'
      },
      question: {
        valid: false,
        errorMessage: 'The Question field is required.'
      },
      otherOption: {
        valid: false,
        errorMessage: 'The Other Response Label field is required.'
      },
      targetSum: {
        valid: false,
        errorMessage: 'Target Sum must be greater than Maximum value.'
      },
      minMax: {
        valid: false,
        errorMessage: 'Maxiumum value must be greater than Minimum value.'
      },
      valid: true,
      showValidationState: false
    };
    _this.focus = {
      id: -1,
      position: 0
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickSaveHandler = _this.onClickSaveHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickRemoveQuestion = _this.onClickRemoveQuestion.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeTab = _this.onChangeTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeKnockout = _this.onChangeKnockout.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCancelRemove = _this.onCancelRemove.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickConfirmRemove = _this.onClickConfirmRemove.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeFeedbackHint = _this.onChangeFeedbackHint.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeFeedbackPositive = _this.onChangeFeedbackPositive.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeFeedbackNegative = _this.onChangeFeedbackNegative.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeConditionalExpression = _this.onChangeConditionalExpression.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickCancel = _this.onClickCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickConfirmCancel = _this.onClickConfirmCancel.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionBuilderEditDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        _mounted: true,
        validationState: this.trueValidationState
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.state._mounted && !(0, _lodash.default)(this.props.edit, nextProps.edit)) {
        var scenario = (0, _get.default)(nextProps, 'edit.scenario', '');
        var edit = (0, _PctyQuestionBuilder2.assignOptionIds)(nextProps.edit);

        // set the validation to true when the drawer closes so that when it opens we are not in the error state;
        var validationState = !nextProps.edit ? {
          validationState: this.trueValidationState
        } : {};
        this.setState(_objectSpread(_objectSpread({
          tab: nextProps.activeTab === 'conditional' ? 1 : 0,
          edit: edit,
          initialEdit: edit
        }, validationState), {}, {
          showScenario: !!scenario,
          rawScenarioContentState: !!scenario ? (0, _inputWysiwyg.fromHtml)(scenario) : null
        }));
      }
    }
  }, {
    key: "onChange",
    value: function onChange(edit, validationState) {
      var newState = _objectSpread(_objectSpread({}, this.state), {}, {
        edit: edit
      });
      if (validationState) {
        newState = _objectSpread(_objectSpread({}, newState), {}, {
          validationState: validationState
        });
      }
      this.setState(newState);
    }
  }, {
    key: "onChangeFeedbackHint",
    value: function onChangeFeedbackHint(_ref) {
      var id = _ref.id,
        value = _ref.value;
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        hint: value
      });
      this.setState({
        edit: edit
      });
    }
  }, {
    key: "onChangeFeedbackPositive",
    value: function onChangeFeedbackPositive(_ref2) {
      var id = _ref2.id,
        value = _ref2.value;
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        correctFeedback: value
      });
      this.setState({
        edit: edit
      });
    }
  }, {
    key: "onChangeConditionalExpression",
    value: function onChangeConditionalExpression(visibleIf) {
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        visibleIf: visibleIf
      });
      this.setState({
        edit: edit
      });
    }
  }, {
    key: "onChangeFeedbackNegative",
    value: function onChangeFeedbackNegative(_ref3) {
      var id = _ref3.id,
        value = _ref3.value;
      var edit = _objectSpread(_objectSpread({}, this.state.edit), {}, {
        incorrectFeedback: value
      });
      this.setState({
        edit: edit
      });
    }
  }, {
    key: "onClickSaveHandler",
    value: function onClickSaveHandler() {
      // only validate on click save
      var validationState = (0, _PctyQuestionBuilder2.validate)(this.state.edit, true, this.props.builderType);
      if (!validationState.valid) {
        this.setState({
          validationState: validationState,
          tab: 0
        });
        return;
      }
      this.focus = {
        id: -1,
        position: 0
      };
      this.props.onClickSaveEditing((0, _PctyQuestionBuilder2.removeOptionIds)(this.state.edit));
    }
  }, {
    key: "onClickRemoveQuestion",
    value: function onClickRemoveQuestion() {
      var modals = {
        leave: true,
        areYouSure: false
      };

      // only display the modal for surveys if they actually made changes!
      var displayModal = true;
      if (this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey) {
        displayModal = !(0, _lodash.default)(this.state.edit, this.state.initialEdit);
      }
      if (!displayModal) {
        this.onClickConfirmRemove();
        return;
      }
      if (this.props.drawerContext === 'edit') {
        modals = {
          leave: false,
          areYouSure: true
        };
      }
      this.setState({
        modals: modals
      });
    }
  }, {
    key: "onChangeTab",
    value: function onChangeTab(tab) {
      this.setState({
        tab: tab
      });
    }

    // eslint-disable-next-line no-unused-vars
  }, {
    key: "onChangeKnockout",
    value: function onChangeKnockout(id, index, value) {
      this.setState({
        edit: _objectSpread(_objectSpread({}, this.state.edit), {}, {
          knockout: !this.state.edit.knockout
        })
      });
    }
  }, {
    key: "onCancelRemove",
    value: function onCancelRemove() {
      this.setState({
        modals: {
          leave: false,
          areYouSure: false
        }
      });
    }
  }, {
    key: "onClickConfirmRemove",
    value: function onClickConfirmRemove() {
      this.setState({
        modals: {
          leave: false,
          areYouSure: false
        }
      });
      this.props.onClickConfirmRemove(this.props.edit.id);
    }
  }, {
    key: "onClickConfirmCancel",
    value: function onClickConfirmCancel() {
      this.setState({
        modals: {
          leave: false,
          areYouSure: false
        }
      });
      this.props.onClickCancelEditing();
    }
  }, {
    key: "onClickCancel",
    value: function onClickCancel() {
      // only display the  modal for surveys if they actually made changes!
      var displayModal = true;
      if (this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey) {
        displayModal = !(0, _lodash.default)(this.state.edit, this.state.initialEdit);
      }
      if (!displayModal) {
        this.onClickConfirmCancel();
        return;
      }
      this.setState({
        modals: {
          leave: true,
          areYouSure: false
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_modal.Modal, {
        headerText: "Leave Question",
        id: "remove-question-modal",
        onCancel: this.onCancelRemove,
        open: this.state.modals.leave,
        size: "small"
      }, _p || (_p = /*#__PURE__*/_react.default.createElement("p", null, "Are you sure you want to leave editing your question? Any changes made will be lost.")), /*#__PURE__*/_react.default.createElement(_modal.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
        onClick: this.props.drawerContext === 'edit' ? this.onClickConfirmCancel : this.onClickConfirmRemove
      }, "Confirm"), /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
        "data-dismiss": "modal",
        onClick: this.onCancelRemove,
        type: "outline"
      }, "Cancel"))), /*#__PURE__*/_react.default.createElement(_modal.Modal, {
        headerText: "Are You Sure?",
        id: "remove-question-modal",
        onCancel: this.onCancelRemove,
        open: this.state.modals.areYouSure,
        size: "small"
      }, _p2 || (_p2 = /*#__PURE__*/_react.default.createElement("p", null, "Are you sure you want to remove this question?")), /*#__PURE__*/_react.default.createElement(_modal.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
        onClick: this.onClickConfirmRemove
      }, "Confirm"), /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
        "data-dismiss": "modal",
        onClick: this.onCancelRemove,
        type: "outline"
      }, "Cancel"))), /*#__PURE__*/_react.default.createElement(_drawer.Drawer, {
        id: "create-".concat(this.props.builderType, "-edit-drawer"),
        onClose: _PctyQuestionBuilder2.defaultFunction,
        open: !!this.props.edit
      }, /*#__PURE__*/_react.default.createElement(_layout.Header, {
        renderActionArea: function renderActionArea() {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _this2.renderRemoveOrCancelButton(), /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
            id: "".concat(_this2.props.id, "-drawer-save"),
            onClick: function onClick() {
              return setTimeout(_this2.onClickSaveHandler, 200);
            }
          }, "Save"));
        },
        title: "Edit Question ".concat(this.props.number > 0 ? this.props.number : '')
      }), /*#__PURE__*/_react.default.createElement(_banner.Banner, {
        automationId: "error-banner",
        id: "error-banner",
        onDismiss: function onDismiss() {
          return console.log('onDismiss');
        },
        type: "error",
        visible: !this.state.validationState.valid && this.state.validationState.showValidationState
      }, _p3 || (_p3 = /*#__PURE__*/_react.default.createElement("p", null, 'Please ensure you have completed all required fields.'))), this.renderTabs()));
    }
  }, {
    key: "renderRemoveOrCancelButton",
    value: function renderRemoveOrCancelButton() {
      if (this.props.drawerContext === 'edit') {
        return /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
          id: "".concat(this.props.id, "-drawer-cancel"),
          onClick: this.onClickCancel
        }, "Cancel");
      }
      return /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
        id: "".concat(this.props.id, "-drawer-remove"),
        onClick: this.onClickRemoveQuestion
      }, this.props.drawerContext === 'edit' && this.props.builderType !== _PctyQuestionBuilder.BUILDER_TYPE.survey ? 'Remove' : 'Cancel');
    }
  }, {
    key: "getQuestion",
    value: function getQuestion() {
      if (this.props.edit.fromQuestionBank || this.state.edit.fromQuestionBank) return null;
      var questionTabText = 'Question and Answers';
      if (this.props.builderType !== _PctyQuestionBuilder.BUILDER_TYPE.survey && [_questionBuilder.QUESTION_TYPE.paragraph, _questionBuilder.QUESTION_TYPE.title].indexOf(this.state.edit.typeId) < 0) {
        questionTabText = 'Enter your text';
      } else if (this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey && [_questionBuilder.QUESTION_TYPE.paragraph, _questionBuilder.QUESTION_TYPE.title, _questionBuilder.QUESTION_TYPE.video].indexOf(this.state.edit.typeId) >= 0) {
        questionTabText = 'Content';
      } else if (this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey) {
        questionTabText = 'Question';
      }
      var showErrors = !this.state.validationState.valid && this.state.validationState.showValidationState;
      var classes = showErrors ? 'content-tab-invalid' : '';
      return /*#__PURE__*/_react.default.createElement(_tabs.Tab, {
        className: classes,
        error: showErrors,
        id: "".concat(this.props.id, "-tab-question"),
        text: questionTabText
      }, /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit.default, {
        builderType: this.props.builderType,
        edit: this.state.edit,
        id: "".concat(this.props.id, "-edit"),
        includeScenario: this.props.builderType !== _PctyQuestionBuilder.BUILDER_TYPE.survey,
        number: this.props.number,
        onChange: this.onChange,
        onGetSingleManageVideoToken: this.props.onGetSingleManageVideoToken,
        showValidationState: this.state.validationState.showValidationState,
        validationState: this.state.validationState,
        videoStudioEnabled: this.props.videoStudioEnabled,
        questionCommentsEnabled: this.props.questionCommentsEnabled
      }));
    }
  }, {
    key: "getAutoFail",
    value: function getAutoFail() {
      return /*#__PURE__*/_react.default.createElement(_tabs.Tab, {
        id: "".concat(this.props.id, "-tab-auto-fail"),
        key: "".concat(_lodash2.default, "-tab-auto-fail"),
        text: "Auto-Fail"
      }, /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit2.default, {
        bannerText: _PctyQuestionBuilder.EDIT_DRAWER.bannerText[this.props.builderType],
        inputText: _PctyQuestionBuilder.EDIT_DRAWER.inputText[this.props.builderType],
        onChangeKnockout: this.onChangeKnockout,
        selected: !!this.state.edit.knockout
      }));
    }
  }, {
    key: "getConditionalDisplay",
    value: function getConditionalDisplay() {
      var _this3 = this;
      var isTriggerTypeQuestion = function isTriggerTypeQuestion(item) {
        return item.id !== _this3.state.edit.id && (item.typeId === _questionBuilder.QUESTION_TYPE.checkbox || item.typeId === _questionBuilder.QUESTION_TYPE.multipleChoice || item.typeId === _questionBuilder.QUESTION_TYPE.ratingScale || item.typeId === _questionBuilder.QUESTION_TYPE.starRating || item.typeId === _questionBuilder.QUESTION_TYPE.dropdownList);
      };
      var triggerQuestions = !this.props.questions ? [] : this.props.questions.filter(function (x) {
        return isTriggerTypeQuestion(x);
      });
      var conditionalExpression = this.state.edit.visibleIf || '';
      return /*#__PURE__*/_react.default.createElement(_tabs.Tab, {
        id: "".concat(this.props.id, "-tab-conditional"),
        key: "".concat(_lodash2.default, "-tab-conditional"),
        text: "Conditional Display"
      }, /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit4.default, {
        bannerText: triggerQuestions.length > 0 ? _PctyQuestionBuilder.EDIT_DRAWER.conditionalText[this.props.builderType] : _PctyQuestionBuilder.EDIT_DRAWER.conditionalText['noQuestions'],
        onChangeConditionalExpression: this.onChangeConditionalExpression,
        conditionalExpression: conditionalExpression,
        questions: triggerQuestions
      }));
    }
  }, {
    key: "getHintsAndResponses",
    value: function getHintsAndResponses() {
      return /*#__PURE__*/_react.default.createElement(_tabs.Tab, {
        id: "".concat(this.props.id, "-tab-hints"),
        key: "".concat(_lodash2.default, "-tab-hints"),
        text: "Hints and Answer Responses"
      }, /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit3.default, {
        correctFeedback: this.state.edit.correctFeedback,
        hint: this.state.edit.hint,
        incorrectFeedback: this.state.edit.incorrectFeedback,
        onChangeFeedbackHint: this.onChangeFeedbackHint,
        onChangeFeedbackNegative: this.onChangeFeedbackNegative,
        onChangeFeedbackPositive: this.onChangeFeedbackPositive
      }));
    }
  }, {
    key: "getSecondaryTabs",
    value: function getSecondaryTabs() {
      if (this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey) {
        if (this.props.enableConditionalQuestions) {
          var surveysTabs = [this.getConditionalDisplay()];
          return surveysTabs;
        }
        return null;
      }

      // content items don't have secondary tabs other than conditional (if enabled)
      if ([_questionBuilder.QUESTION_TYPE.paragraph, _questionBuilder.QUESTION_TYPE.title, _questionBuilder.QUESTION_TYPE.video].indexOf(this.state.edit.typeId) >= 0) return null;
      var tabs = [this.getAutoFail(), this.getHintsAndResponses()];
      return tabs;
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      if (!this.state.edit) return;
      var tabProps = {
        defaultPadding: true,
        activeIndex: this.state.edit.fromQuestionBank ? 0 : this.state.tab,
        onChange: this.onChangeTab
      };
      return /*#__PURE__*/_react.default.createElement(_tabs.Tabs, tabProps, this.getQuestion(), this.getSecondaryTabs());
    }
  }]);
  return PctyQuestionBuilderEditDrawer;
}(_react.Component);
PctyQuestionBuilderEditDrawer.propTypes = {
  id: _propTypes.default.string.isRequired,
  builderType: _propTypes.default.oneOf([_PctyQuestionBuilder.BUILDER_TYPE.quiz, _PctyQuestionBuilder.BUILDER_TYPE.survey]),
  drawerContext: _propTypes.default.oneOf(['edit', 'new']),
  activeTab: _propTypes.default.oneOf(['general', 'autofail', 'hint', 'knockout', 'conditional']),
  edit: _propTypes.default.object,
  onClickSaveEditing: _propTypes.default.func.isRequired,
  onClickCancelEditing: _propTypes.default.func.isRequired,
  onClickConfirmRemove: _propTypes.default.func.isRequired,
  onGetSingleManageVideoToken: _propTypes.default.func.isRequired,
  number: _propTypes.default.number.isRequired,
  enableConditionalQuestions: _propTypes.default.bool,
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    typeId: _propTypes.default.number.isRequired,
    scenario: _propTypes.default.string,
    question: _propTypes.default.string.isRequired,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      value: _propTypes.default.string.isRequired
    })),
    answers: _propTypes.default.arrayOf(_propTypes.default.shape({
      optionId: _propTypes.default.string.isRequired
    })),
    knockout: _propTypes.default.bool,
    hint: _propTypes.default.string,
    correctFeedback: _propTypes.default.string,
    incorrectFeedback: _propTypes.default.string
  })),
  videoStudioEnabled: _propTypes.default.bool.isRequired,
  questionCommentsEnabled: _propTypes.default.bool.isRequired
};
var _default = exports.default = PctyQuestionBuilderEditDrawer;